import { ChainId, Currency, JSBI, Pair, TokenAmount } from '../../sdk'
import { wrappedCurrency } from '../../utils/wrappedCurrency'

/** Persiste el par en Redux/localStorage para que aparezca en «Mis posiciones LP». */
export function trackLiquidityPair(
  addPair: (pair: Pair) => void,
  chainId: ChainId,
  currencyA: Currency,
  currencyB: Currency,
  existingPair?: Pair | null,
): void {
  if (existingPair) {
    addPair(existingPair)
    return
  }

  const tokenA = wrappedCurrency(currencyA, chainId)
  const tokenB = wrappedCurrency(currencyB, chainId)
  if (!tokenA || !tokenB) return

  addPair(new Pair(new TokenAmount(tokenA, JSBI.BigInt(0)), new TokenAmount(tokenB, JSBI.BigInt(0))))
}
